import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';

export const tokenAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';
  const token = isBrowser ? localStorage.getItem('tokenAuth') : null;

  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    : req;

  return next(authReq).pipe(
    tap((event) => {
      if (isBrowser && event.type === HttpEventType.Response) {
        const newToken = event.headers.get('vendure-auth-token');

        if (newToken) {
          localStorage.setItem('tokenAuth', newToken);
        }
      }
    }),
  );
};
